<template>
    <div>
         <Modal
            v-model="giveUpFollowShow"
            title="放弃跟进 "
            :mask-closable="false"
            :closable="false">
            <Alert type="warning">该客户将从您的客户和回访列表消失，请确认是否放弃</Alert>
            <Form ref="formValidate" :model="formValidate" :label-width="80">
                <FormItem :label-width="0" prop="type">
                    <RadioGroup v-model="formValidate.type" @on-change="changeRadio">
                        <Radio label="1">签单几率低</Radio>
                        <Radio label="2">数据有误</Radio>
                        <Radio label="3">战败</Radio>
                        <Radio label="4">其他</Radio>
                    </RadioGroup>
                </FormItem>
                <FormItem :label-width="0" v-if="descShow_3" prop="descShow_3">
                    <Input v-model="formValidate.descShow_3" type="textarea" :maxlength="200" :autosize="{minRows: 2,maxRows: 5}" placeholder="必填：请在200字内填写战败原因"></Input>
                </FormItem>
                <FormItem :label-width="0" v-if="descShow_4" prop="descShow_4">
                    <Input v-model="formValidate.descShow_4" type="textarea" :maxlength="200" :autosize="{minRows: 2,maxRows: 5}" placeholder="必填：请在200字内填写放弃原因"></Input>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" :loading="followLoading" @click="handleCancel">
                    <span v-if="!followLoading">取消</span>
                    <span v-else>
                        放弃跟进中...
                    </span>
                </Button>
                <Button type="primary" size="large" :loading="followLoading" @click="handleSubmit">
                    <span v-if="!followLoading">确定</span>
                    <span v-else>
                        放弃跟进中...
                    </span>
                </Button>
            </div>
        </Modal>
    </div>
</template>
<script>
export default {
    name:"CRM_giveUpFollow",
    props:["giveUpFollowShow","member_ids","type"],
    data(){
        return{
            descShow_3:false,
            descShow_4:false,
            followLoading:false,
            formValidate:{
                type:"",
                descShow_3:"",
                descShow_4:""
            }
        }
    },
    methods: {
        apiGiveUp(){
            let member_ids = []
            for(let item of this.member_ids){
                member_ids.push(item.id)
            }
            let params = {
                member_ids:member_ids,
                abandon_cause:this.formValidate.type,
            }
            if(this.formValidate.type == '3'){
                params.abandon_remark = this.formValidate.descShow_3
            }
            if(this.formValidate.type == '4'){
                params.abandon_remark = this.formValidate.descShow_4
            }
            this.followLoading=true
            let url = ''
            this.type == 'all' ? url=api.myMemberBatchAbandonFollowUser : url=api.myMemberAbandonFollowUser
            serve.fetchPut(url,params).then(data => {
                console.log(data)
                this.$Message.success('放弃跟进成功')
                this.followLoading=false
                this.$emit("giveUpFollowEven", false,true)  
            }).catch((error)=>{
                this.followLoading=false
                this.$Message.error(error.response.data.message);
            })
        },
        changeRadio(name){
            if(name == 4){
                this.descShow_3 = false
                this.descShow_4 = true
                return
            }
            if(name == 3){
                this.descShow_4 = false
                this.descShow_3 = true
                return
            }
            this.descShow_3 = false
            this.descShow_4 = false
            
        },
        handleSubmit () {
            if(this.formValidate.type == ''){
                this.$Message.warning('请选择');
                return
            }
            if(this.formValidate.type == "3"){
                if(this.formValidate.descShow_3 == ''){
                    this.$Message.warning('请输入战败原因')
                    return
                }
            }
            if(this.formValidate.type == "4"){
                if(this.formValidate.descShow_4 == ''){
                    this.$Message.warning('请输入放弃原因')
                    return
                }
            }
            this.apiGiveUp()
        },
        handleCancel () {
            this.$emit("giveUpFollowEven", false)
        }
    },
    watch:{
        giveUpFollowShow(val){
            if(val){
                this.descShow_3 = false
                this.descShow_4 = false
                this.formValidate.descShow_3 = ''
                this.formValidate.descShow_4 = ''
                this.$refs.formValidate.resetFields()
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/commonTmp/CRM/CRM_giveUpFollow.vue